// Only a known service can bypass service selection; trip validation remains mandatory.
export function publicBookingEntry(search = "") {
  const service = new URLSearchParams(search).get("service");
  return service === "transfer" || service === "charter"
    ? { service, step: 1 }
    : { service: null, step: 0 };
}
